import { render, staticRenderFns } from "./practicalActivityAdd.vue?vue&type=template&id=71cf9221&scoped=true"
import script from "./practicalActivityAdd.vue?vue&type=script&lang=js"
export * from "./practicalActivityAdd.vue?vue&type=script&lang=js"
import style0 from "./practicalActivityAdd.vue?vue&type=style&index=0&id=71cf9221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf9221",
  null
  
)

export default component.exports